<template>
  <div id="ReportAdminIndex">
    <BaseTitle :title="$t('menu.report_school')" />
    <v-row class="mb-7">
      <v-col cols="12" md="6">
        <v-card class="mb-8">
          <div class="pa-5">
            <h3 class="mb-2">{{ $t('content.total_student') }}</h3>
            <v-progress-linear :value="percentage" color="secondary" height="38" style="border-radius: 19px;">
              <!-- <strong style="color: #FFFFFF;">{{ chartData.totalStudent.totalStudent }}</strong> -->
              <div class="d-flex justify-space-between" :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'" flat tile>
                <strong>{{ $t('content.total_student') }} : {{ totalStudent }}</strong>

                <strong class="ml-16">{{ $t('content.max_student') }} : {{ outof }} </strong>
              </div>
            </v-progress-linear>
          </div>
        </v-card>
        <v-card>
          <div class="pa-5">
            <h3 class="mb-2">{{ $t('content.school_detail') }}</h3>
            <v-row v-for="({ label, key }, index) in schoolFields" :key="index">
              <v-col md="4">{{ label }} : </v-col>
              <v-col md="8">{{ $get(schoolData, key, '-') }}</v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <!-- <v-card style="height: 620px">
          <div class="pa-5 d-flex flex-column">
            <h3>{{ $t('content.total_class') }}</h3>
            <div class="d-flex align-center justify-center" style="height: 500px">
              <chart type="donut" :options="chart.chartOptions" :series="chart.series" width="500" />
              <NoData v-if="!chart.series.length" />
            </div>
          </div>
        </v-card> -->
        <v-card style="height: 620px">
          <h3 class="pa-5">{{ $t('content.total_class') }}</h3>
          <div class="succ">
            <div class="succ-content">
              <chart type="donut" v-if="chart.chartOptions.total >= 1" :options="chart.chartOptions" :series="chart.series" width="500" />
              <div v-if="!chart.chartOptions.total">
                <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
                <h1 class="succ-heading">{{ $t('nodata_title') }}</h1>
                <div class="succ-content mb-8">{{ $t('nodata_body') }}</div>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.school_list') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <v-progress-circular class="text-center" v-if="table.loading === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div
          v-for="item in listSchool"
          :key="item.schoolId"
          class="border-item"
          @click="showDetail(item)"
          style="
  cursor: pointer;"
        >
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="bank" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="11" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ item.name }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('table.city') }}:
                      <strong>{{ item.cityName }}</strong>
                      |
                      <span class="ml-3 mr-3"
                        >{{ $t('table.province') }} :
                        <strong>{{ item.provinceName }}</strong>
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!listSchool.length" />
        <!-- <v-data-table :headers="tableHeader" :items="items" :loading="table.loading" hide-default-footer class="table-custom" @click:row="showDetail">
          <template #top>
            <table-header @fetch="getData" />
          </template>
          <template #no-data> <NoData /> </template>
        </v-data-table>
        <table-footer @fetch="getData" /> -->
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
// import TableHeader from '@/components/table/TableHeader';
// import TableFooter from '@/components/table/TableFooter';
import Chart from 'vue-apexcharts';
import NoData from '@/components/table/NoData';

export default {
  name: 'ReportAdminIndex',
  components: {
    BaseTitle,
    // TableHeader,
    // TableFooter,
    Chart,
    NoData
  },
  computed: {
    ...mapGetters({
      items: 'School/items'
    }),
    tableHeader() {
      return [
        { text: this.$t('table.school_name'), value: 'name' },
        { text: this.$t('table.province'), value: 'provinceName', width: 300 },
        { text: this.$t('table.city'), value: 'cityName', width: 300 }
      ];
    },
    schoolFields() {
      return [
        { label: this.$t('form.school_name'), key: 'name' },
        { label: this.$t('form.total_user'), key: 'totalUser' },
        { label: this.$t('form.telephone'), key: 'phoneNumber' },
        { label: this.$t('form.email'), key: 'email' },
        { label: this.$t('form.website'), key: 'webUrl' },
        { label: this.$t('form.school_address'), key: 'address' },
        { label: this.$t('form.province'), key: 'provinceName' },
        { label: this.$t('form.city'), key: 'cityName' },
        { label: this.$t('form.postal_code'), key: 'postalCode' }
      ];
    },
    percentage() {
      return this.chartData?.totalStudent?.percentage;
    },
    totalStudent() {
      return this.chartData?.totalStudent?.totalStudent;
    },
    outof() {
      return this.chartData?.totalStudent?.outOf;
    }
  },
  data: () => ({
    knowledge: 80,
    schoolData: {},
    chartData: {},
    listSchool: [],
    search: '',
    chart: {
      series: [100, 0, 0],
      chartOptions: {
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  label: 'Total Class',
                  formatter: function(w) {
                    return w.globals.seriesTotals.length;
                  }
                }
              }
            }
          }
        },
        total: 1,
        labels: ['X', 'B', 'XI']
      }
    },
    table: {
      loading: false
    }
  }),
  watch: {
    'table.options': function() {
      this.getData();
    }
  },
  methods: {
    getData() {
      // this.table.loading = true;
      // // eslint-disable-next-line no-unused-vars
      // return new Promise(resolve => {
      //   this.$store
      //     .dispatch('School/fetchList', { ...this.form, ...this.table.options })
      //     .then(res => resolve(res))
      //     .finally(() => (this.table.loading = false));
      // });
      this.table.loading = true;
      this.$store
        .dispatch('School/fetchList', {
          search: this.search
        })
        .then(data => {
          this.listSchool = data;

          if (data.length) this.showDetail(data[0]);
        })
        .finally(() => (this.table.loading = false));
    },
    showDetail(item) {
      this.$store.dispatch('School/fetchDetail', item.schoolId).then(res => (this.schoolData = { ...this.schoolData, ...item, ...res }));
      this.$store.dispatch('School/fetchDetailChart', item.schoolId).then(res => {
        this.chartData = res;
        let labels = res.totalClass.classes.reduce((acc, row) => {
          row.gradeName = row.gradeName.length > 30 ? row.gradeName.substring(0, 30) + '...' : row.gradeName;
          acc.push(row.gradeName);
          return acc;
        }, []);
        let percen = res.totalClass.classes.reduce((acc, row) => {
          acc.push(row.percentage);
          return acc;
        }, []);

        this.chart.series = percen;
        this.chart.chartOptions = {
          plotOptions: {
            pie: {
              expandOnClick: false,
              donut: {
                labels: {
                  show: true,
                  total: {
                    show: true,
                    label: 'Total Class',
                    formatter: function() {
                      return res.totalClass.totalClass;
                    }
                  }
                }
              }
            }
          },
          total: res.totalClass.totalClass,
          labels: labels
        };
      });
    }
  },
  created() {
    this.$store.commit('table/RESET_PAGEABLE');
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    font-size: 12px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;
  }
}

.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
